const state = {
    /** Init variable */

     // En prod
     //StoreApi: 'https://admin-fibre.gigamedia.net',
     // En local
     // StoreApi: process.env.VUE_APP_URL_API,
    StoreApiUsername : 'api_config_fibre',
    StoreApiPassword :  'vgBhdkbdkly7RtNJ@694The!!J7R41vQ6cz0pUo4^cDnfn$$7c' ,
    StoreJwtToken : null,
    StoreApi: process.env.VUE_APP_URL_API,
    StorePays: null,
    //StoreEnvWeb: 'Webshop',
    StoreEnvWeb: null,
    ContactForm: {},
    StoreReductionPays: false,
    StoreReductionMessage: null,
    StoreEnv: 'Tous', 
    //StoreSitesIframe: ["https://customercare.gigamedia.net", "https://gigamedia.net"],
    //Activer pour afficher la data à chaque selection
    StoreDebugApp: false,

}
const mutations = {
  /** Maj prePanier */
  PUT_ENV_WEB(state, source ) {
     state.StoreEnvWeb= source ;
   },
}
export default {
    state,
    mutations,
}